<script lang="ts" setup>
  import { toRefs } from 'vue'

  import type { EmployeeNotificationJsonldDefaultRead } from '@/api'

  interface Props {
    notification: EmployeeNotificationJsonldDefaultRead
  }

  const props = defineProps<Props>()
  const { notification } = toRefs(props)
</script>

<template>
  <div
    :class="{ 'opacity-50': true }"
    class="min-w-0">
    <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
      <p class="whitespace-nowrap">
        {{ $formatter.DateTimeRelative(notification.createdAt, { threshold: { d: 1 } }) }}
      </p>
    </div>
    <div class="flex items-start gap-x-3">
      <p class="text-sm font-semibold leading-6 text-gray-900">Unbekannter Typ: {{ notification.type }}</p>
      {{ notification }}
    </div>
  </div>
</template>
